export default __webpack_public_path__ + "static/media/banner1.bdc8c0b7.jpeg";